var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 756,
    height: 679,
    viewBox: "0 0 756 679",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.513531,
    y1: 1.31859e-8,
    x2: 0.513481,
    y2: 679,
    stroke: "url(#paint0_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 63.5145,
    y1: 1.15383e-8,
    x2: 63.5145,
    y2: 679,
    stroke: "url(#paint1_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 44.9318,
    x2: 756,
    y2: 44.9318,
    stroke: "url(#paint2_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 90.3756,
    x2: 756,
    y2: 90.3756,
    stroke: "url(#paint3_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 135.821,
    x2: 756,
    y2: 135.821,
    stroke: "url(#paint4_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 181.267,
    x2: 756,
    y2: 181.267,
    stroke: "url(#paint5_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 226.711,
    x2: 756,
    y2: 226.711,
    stroke: "url(#paint6_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 272.156,
    x2: 756,
    y2: 272.156,
    stroke: "url(#paint7_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 317.601,
    x2: 756,
    y2: 317.601,
    stroke: "url(#paint8_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 363.045,
    x2: 756,
    y2: 363.045,
    stroke: "url(#paint9_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 408.49,
    x2: 756,
    y2: 408.49,
    stroke: "url(#paint10_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 453.935,
    x2: 756,
    y2: 453.935,
    stroke: "url(#paint11_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 499.38,
    x2: 756,
    y2: 499.38,
    stroke: "url(#paint12_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 544.825,
    x2: 756,
    y2: 544.825,
    stroke: "url(#paint13_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 590.27,
    x2: 756,
    y2: 590.27,
    stroke: "url(#paint14_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 635.715,
    x2: 756,
    y2: 635.715,
    stroke: "url(#paint15_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 44.9318,
    x2: 756,
    y2: 44.9318,
    stroke: "url(#paint16_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 90.3756,
    x2: 756,
    y2: 90.3756,
    stroke: "url(#paint17_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 135.821,
    x2: 756,
    y2: 135.821,
    stroke: "url(#paint18_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 181.267,
    x2: 756,
    y2: 181.267,
    stroke: "url(#paint19_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 226.711,
    x2: 756,
    y2: 226.711,
    stroke: "url(#paint20_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 272.156,
    x2: 756,
    y2: 272.156,
    stroke: "url(#paint21_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 317.601,
    x2: 756,
    y2: 317.601,
    stroke: "url(#paint22_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 363.045,
    x2: 756,
    y2: 363.045,
    stroke: "url(#paint23_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 408.49,
    x2: 756,
    y2: 408.49,
    stroke: "url(#paint24_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 453.935,
    x2: 756,
    y2: 453.935,
    stroke: "url(#paint25_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 499.38,
    x2: 756,
    y2: 499.38,
    stroke: "url(#paint26_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 544.825,
    x2: 756,
    y2: 544.825,
    stroke: "url(#paint27_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 590.27,
    x2: 756,
    y2: 590.27,
    stroke: "url(#paint28_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5752,
    y1: 635.715,
    x2: 756,
    y2: 635.715,
    stroke: "url(#paint29_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 126.514,
    y1: 1.15383e-8,
    x2: 126.514,
    y2: 679,
    stroke: "url(#paint30_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 189.513,
    y1: 1.15383e-8,
    x2: 189.513,
    y2: 679,
    stroke: "url(#paint31_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 252.514,
    y1: 1.15383e-8,
    x2: 252.514,
    y2: 679,
    stroke: "url(#paint32_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 315.514,
    y1: 1.15383e-8,
    x2: 315.513,
    y2: 679,
    stroke: "url(#paint33_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 378.513,
    y1: 1.15383e-8,
    x2: 378.513,
    y2: 679,
    stroke: "url(#paint34_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 441.514,
    y1: 1.15383e-8,
    x2: 441.514,
    y2: 679,
    stroke: "url(#paint35_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 504.515,
    y1: 1.15383e-8,
    x2: 504.515,
    y2: 679,
    stroke: "url(#paint36_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 567.514,
    y1: 1.15383e-8,
    x2: 567.514,
    y2: 679,
    stroke: "url(#paint37_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 630.513,
    y1: 1.15383e-8,
    x2: 630.513,
    y2: 679,
    stroke: "url(#paint38_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 693.515,
    y1: 1.15383e-8,
    x2: 693.514,
    y2: 679,
    stroke: "url(#paint39_linear_1019_6011)",
    strokeWidth: 1.02706
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1019_6011",
    x1: -0.000025263,
    y1: 339.5,
    x2: -1.00003,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1019_6011",
    x1: 63.0009,
    y1: 339.5,
    x2: 62.0009,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1019_6011",
    x1: 378.788,
    y1: 45.4453,
    x2: 378.788,
    y2: 46.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1019_6011",
    x1: 378.788,
    y1: 90.8892,
    x2: 378.788,
    y2: 91.8892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1019_6011",
    x1: 378.788,
    y1: 136.334,
    x2: 378.788,
    y2: 137.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1019_6011",
    x1: 378.788,
    y1: 181.78,
    x2: 378.788,
    y2: 182.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1019_6011",
    x1: 378.788,
    y1: 227.224,
    x2: 378.788,
    y2: 228.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1019_6011",
    x1: 378.788,
    y1: 272.669,
    x2: 378.788,
    y2: 273.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1019_6011",
    x1: 378.788,
    y1: 318.115,
    x2: 378.788,
    y2: 319.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1019_6011",
    x1: 378.788,
    y1: 363.559,
    x2: 378.788,
    y2: 364.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1019_6011",
    x1: 378.788,
    y1: 409.004,
    x2: 378.788,
    y2: 410.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1019_6011",
    x1: 378.788,
    y1: 454.449,
    x2: 378.788,
    y2: 455.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1019_6011",
    x1: 378.788,
    y1: 499.894,
    x2: 378.788,
    y2: 500.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1019_6011",
    x1: 378.788,
    y1: 545.338,
    x2: 378.788,
    y2: 546.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1019_6011",
    x1: 378.788,
    y1: 590.784,
    x2: 378.788,
    y2: 591.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1019_6011",
    x1: 378.788,
    y1: 636.228,
    x2: 378.788,
    y2: 637.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1019_6011",
    x1: 378.788,
    y1: 45.4453,
    x2: 378.788,
    y2: 46.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1019_6011",
    x1: 378.788,
    y1: 90.8892,
    x2: 378.788,
    y2: 91.8892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1019_6011",
    x1: 378.788,
    y1: 136.334,
    x2: 378.788,
    y2: 137.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1019_6011",
    x1: 378.788,
    y1: 181.78,
    x2: 378.788,
    y2: 182.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1019_6011",
    x1: 378.788,
    y1: 227.224,
    x2: 378.788,
    y2: 228.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1019_6011",
    x1: 378.788,
    y1: 272.669,
    x2: 378.788,
    y2: 273.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1019_6011",
    x1: 378.788,
    y1: 318.115,
    x2: 378.788,
    y2: 319.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1019_6011",
    x1: 378.788,
    y1: 363.559,
    x2: 378.788,
    y2: 364.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1019_6011",
    x1: 378.788,
    y1: 409.004,
    x2: 378.788,
    y2: 410.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1019_6011",
    x1: 378.788,
    y1: 454.449,
    x2: 378.788,
    y2: 455.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1019_6011",
    x1: 378.788,
    y1: 499.894,
    x2: 378.788,
    y2: 500.894,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1019_6011",
    x1: 378.788,
    y1: 545.338,
    x2: 378.788,
    y2: 546.338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1019_6011",
    x1: 378.788,
    y1: 590.784,
    x2: 378.788,
    y2: 591.784,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1019_6011",
    x1: 378.788,
    y1: 636.228,
    x2: 378.788,
    y2: 637.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1019_6011",
    x1: 126.001,
    y1: 339.5,
    x2: 125.001,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1019_6011",
    x1: 189,
    y1: 339.5,
    x2: 188,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1019_6011",
    x1: 252.001,
    y1: 339.5,
    x2: 251.001,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1019_6011",
    x1: 315,
    y1: 339.5,
    x2: 314,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1019_6011",
    x1: 377.999,
    y1: 339.5,
    x2: 376.999,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1019_6011",
    x1: 441,
    y1: 339.5,
    x2: 440,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1019_6011",
    x1: 504.001,
    y1: 339.5,
    x2: 503.001,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1019_6011",
    x1: 567,
    y1: 339.5,
    x2: 566,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1019_6011",
    x1: 630,
    y1: 339.5,
    x2: 629,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1019_6011",
    x1: 693.001,
    y1: 339.5,
    x2: 692.001,
    y2: 339.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F0F2",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/Blocks.bcaf782a7ac0613ee951793d1efc536c.svg";
export { ForwardRef as ReactComponent };